import { OrgPermission } from '@makyoapp/makyo-sdk/models/ACL'

import { useCurrentOrgContext } from '../context/CurrentOrgContext'
import { useOrgsContext } from '../context/OrgsContext'

export function useOrgPerm(perm: OrgPermission) {
  const { orgsPerms } = useOrgsContext()
  const { currentOrg } = useCurrentOrgContext()
  return orgsPerms[currentOrg?.id || '']?.[perm]
}
